/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import WDService from "@/services/wind/diagnostic/WindDiagnosticService";
import DiagnosticRegion from "@/constants/diagnostic/DiagnosticRegion";
import { SetLayoutLinesColor } from "@/components/charts/ChartStyles";
import {
	GET_LOOSENESS_DIAGNOSTIC,
	GET_LOOSENESS_DIAGNOSTIC_SUCCESS,
	GET_LOOSENESS_DIAGNOSTIC_ERROR,
	SHOW_CONCERN_FREQUENCIES,
	HIDE_CONCERN_FREQUENCIES,
} from "@/stores/actions/RollingBearingLoosenessDiagnostic";

import SortingService from "@/services/common/SortingService";

const state = {
	status:          FetchStatus.Init,
	orderData:       [],
	frequencyData:   [],
	error:           {},
	isDialog:        false,
	orderLayout:     {},
	frequencyLayout: {},
	options:         {
		responsive:     true,
		displayModeBar: false,
		showLink:       false,
		displaylogo:    false,
	},
};

const actions = {
	[GET_LOOSENESS_DIAGNOSTIC]: ({ commit }, parameters) =>
	{
		commit(GET_LOOSENESS_DIAGNOSTIC);
		const endPoint = `/WindTurbinesDiagnostic/
			${parameters.resultSetId}/${parameters.shaftLocation}/RollingBearingLooseness/Chart`;
		httpV2.get(endPoint)
			.then((resp) =>
			{
				SortingService.SortListAlphabeticallyByName(resp.data.charts);

				const response = {
					orderChartData:     WDService.CreateChart(resp.data.charts, true),
					frequencyChartData: WDService.CreateChart(resp.data.charts, false),
					isDarkMode:         parameters.isDarkMode,
					regionLocation:     parameters.regionLocation
				};
				commit(GET_LOOSENESS_DIAGNOSTIC_SUCCESS, response);
			})
			.catch((error) =>
			{
				commit(GET_LOOSENESS_DIAGNOSTIC_ERROR, error.response);
			});
	},
	[SHOW_CONCERN_FREQUENCIES]: ({ commit }) =>
	{
		commit(SHOW_CONCERN_FREQUENCIES);
	},
	[HIDE_CONCERN_FREQUENCIES]: ({ commit }) =>
	{
		commit(HIDE_CONCERN_FREQUENCIES);
	},
};

const mutations = {
	[GET_LOOSENESS_DIAGNOSTIC]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_LOOSENESS_DIAGNOSTIC_SUCCESS]: (state, resp) =>
	{
		const formattedRegionLocation = resp.regionLocation === DiagnosticRegion.GEN ?
			`${resp.regionLocation} SHAFT` : resp.regionLocation;

		state.orderData = [];
		state.frequencyData = [];

		state.data = resp;

		state.orderData = resp.orderChartData;
		state.orderLayout = SetLayoutLinesColor(WDService.OrderLayoutModel(), resp.isDarkMode);
		state.orderLayout.shapes = WDService.CreateShapes(resp.orderChartData[0].frequencies);
		state.orderLayout.annotations =
			WDService.CreateAnnotationText(resp.orderChartData[0].frequencies, resp.isDarkMode, formattedRegionLocation);

		state.frequencyData = resp.frequencyChartData;
		state.frequencyLayout = SetLayoutLinesColor(WDService.FrequencyLayoutModel(), resp.isDarkMode);
		state.frequencyLayout.shapes = WDService.CreateShapes(resp.frequencyChartData[0].frequencies);
		state.frequencyLayout.annotations =
			WDService.CreateAnnotationText(
				resp.frequencyChartData[0].frequencies,
				resp.isDarkMode,
				formattedRegionLocation,
			);
		state.status = FetchStatus.Loaded;
	},
	[GET_LOOSENESS_DIAGNOSTIC_ERROR]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
	[SHOW_CONCERN_FREQUENCIES]: (state) =>
	{
		for (let i = 0; i < state.orderLayout.shapes.length; i++)
		{
			state.orderLayout.shapes[i].visible = true;
			state.orderLayout.annotations[i].visible = true;
			state.orderLayout.yaxis.showgrid = false;
			state.orderLayout.xaxis.showgrid = false;

			state.frequencyLayout.shapes[i].visible = true;
			state.frequencyLayout.annotations[i].visible = true;
			state.frequencyLayout.yaxis.showgrid = false;
			state.frequencyLayout.xaxis.showgrid = false;
		}
	},
	[HIDE_CONCERN_FREQUENCIES]: (state) =>
	{
		for (let i = 0; i < state.orderLayout.shapes.length; i++)
		{
			state.orderLayout.shapes[i].visible = false;
			state.orderLayout.annotations[i].visible = false;
			state.orderLayout.yaxis.showgrid = true;
			state.orderLayout.xaxis.showgrid = true;

			state.frequencyLayout.shapes[i].visible = false;
			state.frequencyLayout.annotations[i].visible = false;
			state.frequencyLayout.yaxis.showgrid = true;
			state.frequencyLayout.xaxis.showgrid = true;
		}
	},
};

export default {
	state,
	actions,
	mutations,
};
